import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-password-eye',
  imports: [],
  templateUrl: './password-eye.component.html',
  styleUrl: './password-eye.component.scss'
})
export class PasswordEyeComponent {
  @Input() target!: HTMLInputElement;

  protected visible: boolean = false;

  protected down() {
    this.target.type = "text";
    this.visible = true;
  }

  protected up() {
    this.visible = false;
    this.target.type = "password";
  }
}
